/*
 * @Description:
 * @Author: hejiajun
 * @Date: 2026-02-05 14:43:41
 * @LastEditors: hejiajun
 * @LastEditTime: 2026-02-11 16:05:48
 */
export default async function registerApps(params) {
  const { singleSpa, System, appConfigs, overrideMap, pinia } = params;
  const registrations = appConfigs.map(async (config) => {
    try {
      // 动态导入模块

      let module = null;
      let app = null;

      const url = overrideMap?.imports?.[config.module];
      if (url && url.includes("main.js")) {
        module = await import(
          /* webpackIgnore: true */ overrideMap.imports?.[config.module]
        );
        app = module;
      } else {
        module = await System.import(config.module);
        app = module?.default || module;
      }
      // 注册应用
      singleSpa.registerApplication({
        name: config.name,
        app: () => Promise.resolve(app),
        activeWhen: config.activeWhen,
        customProps: {
          ...config.customProps,
          pinia, // 传递 Pinia 实例给子应用
        },
      });

      return { name: config.name, success: true };
    } catch (error) {
      console.error(`❌ ${config.name} 注册失败:`, error);
      return { name: config.name, success: false, error };
    }
  });

  const results = await Promise.allSettled(registrations);

  // 输出注册结果摘要
  const successCount = results.filter((r) => r.value?.success).length;
  console.log(`📊 应用注册完成：${successCount}/${appConfigs.length} 成功`);

  return results;
}
